<template>
<div class="chat-body">
  <div class="search-wrap">
    <el-select size="mini" v-model="regionId" filterable placeholder="选择战区" clearable>
      <template  v-for="item in regionList">
        <el-option :key="item.value" :label="item.label" :value="item.value" />
        <template v-if="item.children && item.children.length > 0">
          <el-option v-for="item2 in item.children" :key="item2.value" :label="' - ' + item2.label" :value="item2.value" />
        </template>
      </template>
    </el-select>
    <el-select size="mini" v-model="projectId" filterable placeholder="选择项目" clearable>
      <el-option v-for="item in projectListFilter" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
    <el-date-picker size="mini" v-model="dateSpan" type="daterange" align="right" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" style="width: 300px">
    </el-date-picker>
    <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
  </div>

  <div class="chart-title">关键词Top20</div>
  <div id="chart-top" class="chart-1"></div>

  <div class="chart-title">关键词云</div>
  <div id="chart-cloud" class="chart-1"></div>

</div>
</template>

<script>

  import { Loading } from 'element-ui';
  import * as echarts from 'echarts';
  import 'echarts-wordcloud';

export default {
  name: "ConversationProjectFocus",
  data () {
    return {
      regionId: '',
      regionList: [],
      projectId: '',
      projectList: [],
      projectListFilter: [],
      dateSpan: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  //界面没出来前加载
  created() {
    this.getRegionList()
    this.getProjectList()
  },
  mounted() {
    this.getData()
  },
  watch:{
    regionId(val) {
      this.onRegionChange(val)
    },
  },
  //事件
  methods: {
    search() {
      this.getData()
    },
    getRegionList() {
      this.$qwhttp.get('region/options', {}).then( res => {
        if(res.status == 200 && res.data.errcode == 0) {
          this.regionList = this.getRegionTree(0, res.data.data)
        }
      })
    },
    getRegionTree(id, d) {
      let list = []
      for(const k in d) {
        if(d[k].parent_id == id) {
          let item = d[k]
          item.children = this.getRegionTree(item.value, d)
          list.push(item)
        }
      }
      return list
    },
    onRegionChange(val) {
      this.projectListFilter = val ? this.projectList.filter(item => {
        return item.region_id == val
      }) : this.projectList
      this.projectId = ''
    },
    getProjectList() {
      this.$qwhttp.get('project/options', {}).then( res => {
        if(res.status == 200 && res.data.errcode == 0) {
          this.projectList = res.data.data
          this.projectListFilter = res.data.data
        }
      })
    },
    getData() {
      this.$qwhttp.get('project/focus_keywords', {params: {project_id: this.projectId, start_date: this.dateSpan[0], end_date: this.dateSpan[1]}}).then( res => {
        if(res.status == 200 && res.data.errcode == 0) {
            this.createChart(res.data.data)
            this.createChartCloud(res.data.data)
        }
      })
    },
    createChart(d) {

      d = d.sort((a, b) => {
        return a.count > b.count ? -1 : 1
      }).slice(0, 20)

      const keywords = d.map(item => item.keyword)
      const data = d.map(item => item.count)

      let myChart = echarts.init(document.getElementById('chart-top'))
      myChart.setOption({
        visualMap: [
          {
            show: false,
            type: 'continuous',
          }
        ],
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '2%',
          right: '60px',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisLabel: { interval: 0, rotate: 45, margin: 20 },
            name: '关键字',
            data: keywords.map((kw, i) => {
              return {
                value: "Top " + (i+1) + "\n" + kw,
                //value: kw,
                textStyle: {
                  height: 32,
                  lineHeight: 16
                }
              }
            }),
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '出现次数',
            nameGap: 30,
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '出现次数',
            type: 'bar',
            barMaxWidth: 50,
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top',
            },
            data: data
          }
        ]
      });

    },

    createChartCloud(d) {

      // d = d.sort((a, b) => {
      //   return a.count > b.count ? -1 : 1
      // }).slice(0, 20)

      // const keywords = d.map(item => item.keyword)
      // const data = d.map(item => item.count)

      let myChart = echarts.init(document.getElementById('chart-cloud'))

      myChart.setOption({
        textStyle:{
          textBorderColor: '#fff',
          textBorderWidth: 1,
          textBorderType: 'solid',


          textShadowColor: '#ddd',
          textShadowBlur: 3,
          textShadowOffsetX: 1,
          textShadowOffsetY: 1,
          color: function () {
              return 'rgb(' + [
                  Math.round(Math.random() * 160),
                  Math.round(Math.random() * 160),
                  Math.round(Math.random() * 160)
              ].join(',') + ')';
          }
        },
        tooltip: {},
        series: [{
          type: 'wordCloud',
          gridSize: 16,
          keepAspect: false,
          sizeRange: [15, 60],
          rotationRange: [0, 0],
          shape: 'circle',
          data: d.map(item => { return {name: item.keyword, value: item.count}})
        }]
      });



    }
  }
}
</script>
<style scoped lang="scss">
.chat-body{
  box-sizing: border-box;
  position: relative;
  padding: 15px;
}

.text2 {
  color: #FFFFFF;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
  display: flex;
  align-items: center;

  > * {
    margin-right: 5px
  }
}

.chart-1 {
  margin-top: 20px;
  width: 100%;
  height: 300px;
  margin-bottom: 40px;
}

.chart-2 {
  margin-top: 20px;
  width: 300px;
  height: 300px;

}

.chart-title {
  margin-top: 20px;
  font-size: 20px;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Conversation/ProjectFocus.vue